import { ChatBubbleLeftEllipsisIcon } from "@heroicons/react/24/outline";

import { IPart } from "../../models/Part";
import Tooltip from "./Tooltip";

export default function PartNotesIndicator({ part }: { part: IPart }) {
  const noteCount = (part.notes?.length ?? 0) + (part.internalNotes?.length ?? 0);
  if (noteCount === 0) return null;

  return (
    <Tooltip content={`${noteCount} note${noteCount === 1 ? "" : "s"}`}>
      <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-600 ring-1 ring-slate-200">
        <ChatBubbleLeftEllipsisIcon className="h-3.5 w-3.5" />
        {noteCount}
      </span>
    </Tooltip>
  );
}
